/**
 * Mark Fashion Wishlist — self-contained luxury drawer + Vitals sync
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mf_wishlist_v2';
  var API_PATH = '/bundle/api/v2/sf/ws';
  var API_HEADERS = { 'Content-Type': 'application/json; charset=UTF-8' };

  var items = {};
  var productCache = {};
  var drawerOpen = false;
  var toastTimer = null;

  var els = {};

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function heartSvg() {
    return (
      '<span class="mf-wl-btn__icon" aria-hidden="true">' +
      '<svg class="mf-wl-btn__heart" viewBox="0 0 24 24" focusable="false">' +
      '<path class="mf-wl-btn__heart-outline" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>' +
      '</svg></span>'
    );
  }

  function loadStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      items = raw ? JSON.parse(raw) : {};
    } catch (e) {
      items = {};
    }
  }

  function saveStore() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function count() {
    return Object.keys(items).length;
  }

  function has(id) {
    return !!items[String(id)];
  }

  function getVitalsConfig() {
    var d = window.vtlsLiquidData;
    if (!d || !d.spat || !d.shopInfo || !d.shopInfo.id) return null;
    var hosts = d.apiHosts || {};
    return {
      base: String(hosts['8'] || hosts[8] || 'https://wishlist.sqa-api.com').replace(/\/$/, ''),
      shopId: String(d.shopInfo.id),
      spat: d.spat,
    };
  }

  function vitalsUrl(cfg, productId) {
    return cfg.base + API_PATH + '/' + cfg.shopId + '/' + cfg.spat + (productId ? '/' + productId : '');
  }

  function syncVitals(productId, add) {
    var cfg = getVitalsConfig();
    if (!cfg) return;
    fetch(vitalsUrl(cfg, productId), {
      method: add ? 'POST' : 'DELETE',
      credentials: 'omit',
      headers: API_HEADERS,
    }).catch(function () {});
  }

  function formatMoney(cents) {
    if (window.MFMoney) return window.MFMoney.format(cents);
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || window.__MF_MONEY?.format || '${{amount}}');
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function fetchProduct(handle, cb) {
    if (productCache[handle]) {
      cb(productCache[handle]);
      return;
    }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        if (p) productCache[handle] = p;
        cb(p);
      })
      .catch(function () {
        cb(null);
      });
  }

  function metaFromBtn(btn) {
    var card = btn.closest('.mf-product-card, product-card, [data-product-id]');
    var link = card && card.querySelector('a[href*="/products/"]');
    var img = card && card.querySelector('img');
    var titleEl = card && card.querySelector('.mf-product-card__title, [class*="product-title"], h3, h4');
    var priceEl = card && card.querySelector('.mf-product-card__price, [class*="price"]');
    return {
      id: String(btn.dataset.productId),
      handle: btn.dataset.productHandle || '',
      title: titleEl ? titleEl.textContent.trim() : '',
      url: link ? link.href : '/products/' + btn.dataset.productHandle,
      image: img ? img.currentSrc || img.src : '',
      price: priceEl ? priceEl.textContent.trim() : '',
      variantId: btn.dataset.variantId || '',
    };
  }

  function metaFromProductJson(p) {
    var v = p.variants && p.variants[0];
    var compare = v && v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
    return {
      id: String(p.id),
      handle: p.handle,
      title: displayTitle(p.title),
      url: '/products/' + p.handle,
      image: p.featured_image || (p.images && p.images[0]) || '',
      price: v ? formatMoney(v.price) : '',
      comparePrice: compare ? formatMoney(compare) : '',
      available: p.available,
      variantId: v ? String(v.id) : '',
      description: p.description ? p.description.replace(/<[^>]+>/g, '').trim().slice(0, 160) : '',
    };
  }

  function displayTitle(title) {
    if (window.MFProductTitle && window.MFProductTitle.display) {
      return window.MFProductTitle.display(title);
    }
    return String(title || '').replace(/^Mark Fashion\s+/i, '').trim() || String(title || '');
  }

  function stripHtml(html) {
    if (!html) return '';
    return String(html)
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function truncate(text, len) {
    if (!text || text.length <= len) return text || '';
    return text.slice(0, len).replace(/\s+\S*$/, '') + '…';
  }

  function addToCartVariant(variantId, btn, onDone) {
    if (!variantId) return;
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        if (btn) btn.textContent = 'Added ✓';
        closeDrawer();
        var notify = window.MFCartFix && window.MFCartFix.notifyCartUpdated;
        var afterCart = function () {
          if (onDone) onDone();
          else if (window.MFCartFix && typeof window.MFCartFix.open === 'function') {
            window.MFCartFix.open();
          }
        };
        if (notify) {
          notify('mf-wishlist').then(afterCart).catch(afterCart);
        } else {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (cart) {
              if (cart) {
                document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: cart,
                      data: { itemCount: cart.item_count, source: 'mf-wishlist' },
                    },
                  })
                );
              }
            })
            .finally(afterCart);
        }
      })
      .catch(function () {
        if (btn) {
          btn.textContent = 'Try again';
          btn.disabled = false;
        }
      });
  }

  function setBtnState(btn, active) {
    if (!btn) return;
    btn.classList.toggle('mf-wl-btn--active', active);
    btn.classList.toggle('mf-wishlist-btn--active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    var label = btn.querySelector('[data-mf-wl-label], .mf-wl-btn__label');
    if (label && btn.classList.contains('mf-wl-btn--card')) {
      label.textContent = active ? 'Saved' : 'Add to wishlist';
    }
  }

  function popBtn(btn) {
    btn.classList.add('mf-wl-btn--pop');
    setTimeout(function () {
      btn.classList.remove('mf-wl-btn--pop');
    }, 380);
  }

  function updateHeaderCount() {
    var badge = $('[data-mf-wishlist-count]');
    var n = count();
    if (!badge) return;
    if (n > 0) {
      badge.textContent = String(n);
      badge.hidden = false;
      badge.removeAttribute('aria-hidden');
      badge.classList.add('mf-wishlist-header__count--pulse');
      setTimeout(function () {
        badge.classList.remove('mf-wishlist-header__count--pulse');
      }, 450);
    } else {
      badge.textContent = '';
      badge.hidden = true;
      badge.setAttribute('aria-hidden', 'true');
    }
  }

  function showToast(msg, added) {
    if (!els.toast) return;
    els.toast.hidden = false;
    els.toast.innerHTML =
      '<span class="mf-wl-toast__icon">' +
      (added ? '♥' : '♡') +
      '</span><span>' +
      msg +
      '</span>';
    els.toast.classList.add('mf-wl-toast--visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      els.toast.classList.remove('mf-wl-toast--visible');
      setTimeout(function () {
        els.toast.hidden = true;
      }, 350);
    }, 2800);
  }

  function refreshAllButtons() {
    $$('[data-mf-wl-btn], [data-mf-wishlist-btn]').forEach(function (btn) {
      if (btn.dataset.productId) setBtnState(btn, has(btn.dataset.productId));
    });
  }

  function renderDrawer() {
    if (!els.items) return;
    var ids = Object.keys(items);
    if (!ids.length) {
      els.items.innerHTML =
        '<div class="mf-wl-empty">' +
        '<div class="mf-wl-empty__icon">♡</div>' +
        '<p class="mf-wl-empty__title">Your wishlist is empty</p>' +
        '<p class="mf-wl-empty__text">Tap the heart on any product to save it here.</p>' +
        '<a href="/collections/all" class="mf-wl-empty__cta">Explore collection</a>' +
        '</div>';
      if (els.foot) els.foot.hidden = true;
      return;
    }
    if (els.foot) els.foot.hidden = false;

    els.items.innerHTML = ids
      .map(function (id) {
        var it = items[id];
        return (
          '<article class="mf-wl-item" data-mf-wl-item="' +
          id +
          '">' +
          '<a href="' +
          (it.url || '#') +
          '" class="mf-wl-item__img-wrap">' +
          (it.image
            ? '<img class="mf-wl-item__img" src="' + it.image + '" alt="" loading="lazy" width="88" height="110">'
            : '') +
          '</a>' +
          '<div class="mf-wl-item__info">' +
          '<p class="mf-wl-item__title"><a href="' +
          (it.url || '#') +
          '">' +
          (displayTitle(it.title) || 'Product') +
          '</a></p>' +
          '<p class="mf-wl-item__price">' +
          (it.price || '') +
          '</p>' +
          (it.variantId
            ? '<button type="button" class="mf-wl-item__atc" data-mf-wl-atc="' +
              it.variantId +
              '">Add to cart</button>'
            : '<a href="' +
              (it.url || '#') +
              '" class="mf-wl-item__atc">View product</a>') +
          '</div>' +
          '<button type="button" class="mf-wl-item__remove" data-mf-wl-remove="' +
          id +
          '" aria-label="Remove from wishlist">&times;</button>' +
          '</article>'
        );
      })
      .join('');

    $$('[data-mf-wl-remove]', els.items).forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeItem(btn.getAttribute('data-mf-wl-remove'), true);
      });
    });

    $$('[data-mf-wl-atc]', els.items).forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCartVariant(btn.getAttribute('data-mf-wl-atc'), btn);
      });
    });

    ids.forEach(function (id) {
      var it = items[id];
      if (it && it.handle && (!it.image || !it.price)) {
        fetchProduct(it.handle, function (p) {
          if (!p || !items[id]) return;
          var m = metaFromProductJson(p);
          items[id] = Object.assign({}, items[id], m);
          saveStore();
          renderDrawer();
        });
      }
    });
  }

  function addItem(meta, btn) {
    var id = String(meta.id);
    items[id] = meta;
    saveStore();
    syncVitals(id, true);
    if (btn) {
      setBtnState(btn, true);
      popBtn(btn);
    }
    refreshAllButtons();
    updateHeaderCount();
    showToast('Saved to your wishlist', true);
    if (drawerOpen) renderDrawer();
    if (els.pageGrid) renderPage();
    document.dispatchEvent(new CustomEvent('mf:wishlist-changed', { detail: { productId: id, added: true } }));
  }

  function removeItem(id, fromDrawer) {
    id = String(id);
    if (!items[id]) return;
    delete items[id];
    saveStore();
    syncVitals(id, false);
    refreshAllButtons();
    updateHeaderCount();
    showToast('Removed from wishlist', false);
    if (fromDrawer) {
      var row = $('[data-mf-wl-item="' + id + '"]');
      if (row) {
        row.classList.add('mf-wl-item--out');
        setTimeout(renderDrawer, 280);
      } else {
        renderDrawer();
      }
    } else if (drawerOpen) {
      renderDrawer();
    }
    if (els.pageGrid) renderPage();
    document.dispatchEvent(new CustomEvent('mf:wishlist-changed', { detail: { productId: id, added: false } }));
  }

  function toggleItem(btn) {
    var id = btn.dataset.productId;
    if (!id) return;
    if (has(id)) {
      removeItem(id, false);
      setBtnState(btn, false);
      return;
    }
    btn.classList.add('mf-wl-btn--loading');
    var meta = metaFromBtn(btn);
    if (meta.handle) {
      fetchProduct(meta.handle, function (p) {
        btn.classList.remove('mf-wl-btn--loading');
        if (p) meta = metaFromProductJson(p);
        addItem(meta, btn);
      });
    } else {
      btn.classList.remove('mf-wl-btn--loading');
      addItem(meta, btn);
    }
  }

  function isCartDrawerOpen() {
    var cartDlg = document.querySelector('cart-drawer-component dialog');
    return !!(cartDlg && cartDlg.open);
  }

  function openDrawer() {
    if (!els.drawer) return;
    if (isCartDrawerOpen()) return;
    drawerOpen = true;
    els.drawer.hidden = false;
    els.drawer.setAttribute('aria-hidden', 'false');
    if (!isCartDrawerOpen()) {
      document.body.style.overflow = 'hidden';
    }
    requestAnimationFrame(function () {
      els.drawer.classList.add('mf-wl-drawer--open');
    });
    renderDrawer();
  }

  function closeDrawer() {
    if (!els.drawer) return;
    drawerOpen = false;
    els.drawer.classList.remove('mf-wl-drawer--open');
    els.drawer.setAttribute('aria-hidden', 'true');
    els.drawer.style.pointerEvents = 'none';
    if (!isCartDrawerOpen()) {
      document.body.style.overflow = '';
    }
    if (window.MFCartFix && typeof window.MFCartFix.releaseScrollLock === 'function') {
      window.MFCartFix.releaseScrollLock();
    }
    els.drawer.hidden = true;
  }

  function suppressVitalsWishlistUI(root) {
    var scope = root || document;
    $$('[class*="Vtl-Wishlist"], .mf-vitals-wishlist', scope).forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
      el.hidden = true;
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function dedupeWishlistButtons(root) {
    var scope = root || document;
    var mounts = $$(
      '.mf-product-card__media-wrap, .card-gallery, .product-card-gallery, .product-information__media, [data-mf-wl-gallery]',
      scope
    );
    mounts.forEach(function (mount) {
      var btns = $$('[data-mf-wl-btn], [data-mf-wishlist-btn]', mount);
      for (var i = 1; i < btns.length; i++) {
        btns[i].remove();
      }
    });
    $$('.mf-product-card, product-card', scope).forEach(function (card) {
      var cardBtns = $$('[data-mf-wl-btn], [data-mf-wishlist-btn]', card);
      for (var j = 1; j < cardBtns.length; j++) {
        cardBtns[j].remove();
      }
    });
  }

  function upgradeLegacyBtn(btn) {
    if (btn.closest('[class*="Vtl-Wishlist"]') || btn.classList.contains('Vtl-WishlistButton__WishlistIconButton')) {
      return;
    }
    if (btn.dataset.mfWlUpgraded) return;
    btn.dataset.mfWlUpgraded = '1';
    btn.classList.add('mf-wl-btn');
    if (!btn.dataset.mfWlBtn) btn.setAttribute('data-mf-wl-btn', '');
    var inMedia =
      btn.closest('.mf-product-card__media-wrap, .card-gallery, .product-information__media, [data-mf-wl-gallery]') &&
      !btn.classList.contains('mf-wl-btn--inline');
    if (inMedia && !btn.classList.contains('mf-wl-btn--card')) {
      btn.classList.add('mf-wl-btn--card');
      btn.classList.remove('mf-wl-btn--pdp');
    }
    if (!btn.querySelector('.mf-wl-btn__heart')) {
      btn.innerHTML = heartSvg();
    }
    if (inMedia && !btn.querySelector('.mf-wl-btn__label')) {
      btn.insertAdjacentHTML('beforeend', '<span class="mf-wl-btn__label" data-mf-wl-label>Add to wishlist</span>');
    }
  }

  function wireButtons(root) {
    $$('[data-mf-wl-btn], [data-mf-wishlist-btn]', root).forEach(function (btn) {
      upgradeLegacyBtn(btn);
      if (btn.dataset.mfWlWired) return;
      btn.dataset.mfWlWired = '1';
      if (btn.dataset.productId) setBtnState(btn, has(btn.dataset.productId));
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleItem(btn);
      });
    });
  }

  function findCardGalleryMount(card) {
    return (
      card.querySelector('.card-gallery') ||
      card.querySelector('.product-card-gallery') ||
      card.querySelector('.mf-product-card__media-wrap') ||
      card.querySelector('[data-mf-card-media]') ||
      null
    );
  }

  function relocateHorizonWishlist(card) {
    var gallery = findCardGalleryMount(card);
    if (!gallery) return;
    var misplaced = card.querySelector(
      '.product-card__content > [data-mf-wl-btn], .product-card__content > [data-mf-wishlist-btn]'
    );
    if (!misplaced || gallery.contains(misplaced)) return;
    if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';
    gallery.insertBefore(misplaced, gallery.firstChild);
  }

  function injectHorizonCards() {
    $$('product-card[data-product-id], .product-card[data-product-id]').forEach(function (card) {
      if (card.closest('.mf-product-card')) return;
      suppressVitalsWishlistUI(card);
      relocateHorizonWishlist(card);
      if (card.querySelector('[data-mf-wl-btn], [data-mf-wishlist-btn]')) return;
      var id = card.dataset.productId;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = '';
      if (link && link.href) {
        var m = link.href.match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }
      if (!id) return;
      var mount = findCardGalleryMount(card);
      if (!mount) return;
      if (getComputedStyle(mount).position === 'static') mount.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mf-wl-btn mf-wl-btn--card';
      btn.setAttribute('data-mf-wl-btn', '');
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.setAttribute('aria-pressed', 'false');
      btn.dataset.productId = id;
      if (handle) btn.dataset.productHandle = handle;
      btn.innerHTML = heartSvg() + '<span class="mf-wl-btn__label" data-mf-wl-label>Add to wishlist</span>';
      mount.insertBefore(btn, mount.firstChild);
    });
    wireButtons();
  }

  function injectPDPGallery() {
    if (!document.body.classList.contains('template-product') && !window.__MF_PRODUCT) return;
    var media = $('.product-information__media media-gallery, .product-information__media');
    if (!media) return;
    suppressVitalsWishlistUI(media);
    if ($('[data-mf-wl-gallery]')) return;

    if (getComputedStyle(media).position === 'static') {
      media.style.position = 'relative';
    }

    var wrap = document.createElement('div');
    wrap.setAttribute('data-mf-wl-gallery', '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mf-wl-btn mf-wl-btn--card';
    btn.setAttribute('data-mf-wl-btn', '');
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.setAttribute('aria-pressed', 'false');
    if (window.__MF_PRODUCT) {
      btn.dataset.productHandle = window.__MF_PRODUCT.handle;
    }
    var pidEl = document.querySelector('[data-product-id], product-form-component[data-product-id]');
    if (pidEl && pidEl.dataset.productId) {
      btn.dataset.productId = pidEl.dataset.productId;
    }
    btn.innerHTML = heartSvg() + '<span class="mf-wl-btn__label" data-mf-wl-label>Add to wishlist</span>';
    wrap.appendChild(btn);
    media.appendChild(wrap);
    wireButtons(wrap);
  }

  function removeInlinePDPWishlist() {
    $$('[data-mf-wl-pdp]').forEach(function (el) {
      el.remove();
    });
  }

  function injectPDP() {
    /* Inline sidebar wishlist removed — gallery heart only */
    removeInlinePDPWishlist();
  }

  function injectQuickView(product) {
    var mount = $('#mf-qv-wishlist');
    if (!mount || !product) return;
    mount.hidden = false;
    mount.className = 'mf-qv__wishlist-row';
    mount.innerHTML =
      '<button type="button" class="mf-wl-btn mf-wl-btn--inline" data-mf-wl-btn data-product-id="' +
      product.id +
      '" data-product-handle="' +
      product.handle +
      '">' +
      heartSvg() +
      '<span class="mf-wl-btn__label">Add to Wishlist</span></button>';
    wireButtons(mount);
  }

  function renderPageCard(id, it, product) {
    var meta = product ? metaFromProductJson(product) : it;
    var desc = meta.description || (product ? truncate(stripHtml(product.body_html || product.description), 160) : '');
    var priceHtml =
      meta.comparePrice && meta.comparePrice !== meta.price
        ? '<span class="mf-wl-page-card__price-sale">' +
          meta.price +
          '</span><span class="mf-wl-page-card__price-compare">' +
          meta.comparePrice +
          '</span>'
        : '<span class="mf-wl-page-card__price-sale">' + (meta.price || '') + '</span>';
    var available = product ? product.available : meta.available !== false;
    var statusClass = available ? 'mf-wl-page-card__status--in' : 'mf-wl-page-card__status--out';
    var statusText = available ? 'In stock' : 'Sold out';
    var img = meta.image || '';
    var vid = meta.variantId || '';

    return (
      '<article class="mf-wl-page-card" data-mf-wl-page-item="' +
      id +
      '">' +
      '<a href="' +
      (meta.url || '#') +
      '" class="mf-wl-page-card__media">' +
      (img
        ? '<img class="mf-wl-page-card__img" src="' + img + '" alt="" loading="lazy" width="320" height="400">'
        : '<span class="mf-wl-page-card__img-placeholder"></span>') +
      '</a>' +
      '<div class="mf-wl-page-card__body">' +
      '<h2 class="mf-wl-page-card__title"><a href="' +
      (meta.url || '#') +
      '">' +
      (displayTitle(meta.title) || 'Product') +
      '</a></h2>' +
      '<p class="mf-wl-page-card__prices">' +
      priceHtml +
      '</p>' +
      '<p class="mf-wl-page-card__status ' +
      statusClass +
      '">' +
      statusText +
      '</p>' +
      (desc ? '<p class="mf-wl-page-card__desc">' + desc + '</p>' : '') +
      '<div class="mf-wl-page-card__actions">' +
      (available && vid
        ? '<button type="button" class="mf-wl-page-card__atc mf-btn mf-btn--primary" data-mf-wl-page-atc="' +
          vid +
          '">Add to cart</button>'
        : '<a href="' +
          (meta.url || '#') +
          '" class="mf-wl-page-card__atc mf-btn mf-btn--primary">View product</a>') +
      '<a href="' +
      (meta.url || '#') +
      '" class="mf-wl-page-card__view">View details</a>' +
      '<button type="button" class="mf-wl-page-card__remove" data-mf-wl-page-remove="' +
      id +
      '" aria-label="Remove from wishlist">Remove</button>' +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function renderPage() {
    if (!els.pageGrid) return;
    var ids = Object.keys(items);
    var countEl = els.pageCount;
    var emptyEl = els.pageEmpty;

    if (!ids.length) {
      els.pageGrid.innerHTML = '';
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.style.display = '';
      }
      if (countEl) countEl.hidden = true;
      return;
    }

    if (emptyEl) {
      emptyEl.hidden = true;
      emptyEl.style.display = 'none';
    }
    if (countEl) {
      countEl.hidden = false;
      countEl.textContent =
        ids.length + (ids.length === 1 ? ' item saved on this device' : ' items saved on this device');
    }

    els.pageGrid.innerHTML = ids
      .map(function (id) {
        return renderPageCard(id, items[id], null);
      })
      .join('');

    $$('[data-mf-wl-page-remove]', els.pageGrid).forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeItem(btn.getAttribute('data-mf-wl-page-remove'), true);
      });
    });

    $$('[data-mf-wl-page-atc]', els.pageGrid).forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCartVariant(btn.getAttribute('data-mf-wl-page-atc'), btn);
      });
    });

    ids.forEach(function (id) {
      var it = items[id];
      if (!it || !it.handle) return;
      fetchProduct(it.handle, function (p) {
        if (!p || !items[id]) return;
        var m = metaFromProductJson(p);
        items[id] = Object.assign({}, items[id], m);
        saveStore();
        var card = $('[data-mf-wl-page-item="' + id + '"]');
        if (card) {
          card.outerHTML = renderPageCard(id, items[id], p);
          var newCard = $('[data-mf-wl-page-item="' + id + '"]');
          if (newCard) {
            var rm = newCard.querySelector('[data-mf-wl-page-remove]');
            if (rm) {
              rm.addEventListener('click', function () {
                removeItem(rm.getAttribute('data-mf-wl-page-remove'), true);
              });
            }
            var atc = newCard.querySelector('[data-mf-wl-page-atc]');
            if (atc) {
              atc.addEventListener('click', function () {
                addToCartVariant(atc.getAttribute('data-mf-wl-page-atc'), atc);
              });
            }
          }
        }
      });
    });
  }

  function initWishlistPage() {
    els.pageGrid = $('[data-mf-wl-page-grid]');
    els.pageEmpty = $('[data-mf-wl-page-empty]');
    els.pageCount = $('[data-mf-wl-page-count]');
    if (!els.pageGrid) return;
    renderPage();
    if (!window.__mfWlPageBound) {
      window.__mfWlPageBound = true;
      document.addEventListener('mf:wishlist-changed', renderPage);
    }
  }

  function bindDrawer() {
    $$('[data-mf-wl-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    $$('[data-mf-wishlist-trigger], [data-mf-wl-open]').forEach(function (el) {
      if (el.dataset.mfWlOpenWired) return;
      el.dataset.mfWlOpenWired = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerOpen) closeDrawer();
    });
  }

  function initPDPFromPage() {
    if (!window.__MF_PRODUCT) return;
    fetchProduct(window.__MF_PRODUCT.handle, function (p) {
      if (!p) return;
      var m = metaFromProductJson(p);
      $$('[data-mf-wl-gallery] [data-mf-wl-btn]').forEach(function (btn) {
        btn.dataset.productId = m.id;
        btn.dataset.productHandle = m.handle;
        btn.dataset.variantId = m.variantId;
        setBtnState(btn, has(m.id));
      });
    });
  }

  function init() {
    els.drawer = $('#mf-wishlist-drawer');
    els.items = $('[data-mf-wl-items]');
    els.foot = $('[data-mf-wl-foot]');
    els.toast = $('#mf-wl-toast');

    loadStore();
    suppressVitalsWishlistUI();
    bindDrawer();
    wireButtons();
    $$('product-card[data-product-id], .product-card[data-product-id]').forEach(relocateHorizonWishlist);
    dedupeWishlistButtons();
    injectHorizonCards();
    injectPDPGallery();
    injectPDP();
    dedupeWishlistButtons();
    refreshAllButtons();
    updateHeaderCount();
    initPDPFromPage();
    initWishlistPage();

    var domWorkScheduled = false;
    function scheduleDomWork() {
      if (domWorkScheduled) return;
      domWorkScheduled = true;
      requestAnimationFrame(function () {
        domWorkScheduled = false;
        suppressVitalsWishlistUI();
        removeInlinePDPWishlist();
        wireButtons();
        $$('product-card[data-product-id], .product-card[data-product-id]').forEach(relocateHorizonWishlist);
        dedupeWishlistButtons();
        injectHorizonCards();
        injectPDPGallery();
        dedupeWishlistButtons();
      });
    }

    function isCartMutation(mutation) {
      var nodes = [mutation.target];
      if (mutation.addedNodes) {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          nodes.push(mutation.addedNodes[j]);
        }
      }
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!(node instanceof Element)) continue;
        if (node.closest('cart-drawer-component, cart-items-component, .cart-drawer')) return true;
        if (node.matches && node.matches('cart-drawer-component, cart-items-component, .cart-drawer')) return true;
      }
      return false;
    }

    function isProductMutation(mutation) {
      var nodes = [mutation.target];
      if (mutation.addedNodes) {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          nodes.push(mutation.addedNodes[j]);
        }
      }
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!(node instanceof Element)) continue;
        if (
          node.matches &&
          (node.matches('.mf-product-card, product-card, .card-gallery') ||
            node.querySelector('.mf-product-card, product-card'))
        ) {
          return true;
        }
      }
      return false;
    }

    var observer = new MutationObserver(function (mutations) {
      var needs = false;
      for (var i = 0; i < mutations.length; i++) {
        if (isCartMutation(mutations[i])) continue;
        if (isProductMutation(mutations[i])) {
          needs = true;
          break;
        }
      }
      if (needs) scheduleDomWork();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', scheduleDomWork);
    document.addEventListener('mf:recommendations-loaded', scheduleDomWork);

    document.addEventListener('mf:quick-view-opened', function (e) {
      if (e.detail && e.detail.product) injectQuickView(e.detail.product);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MFWishlist = {
    open: openDrawer,
    close: closeDrawer,
    add: addItem,
    remove: removeItem,
    has: has,
    count: count,
    renderPage: renderPage,
    getItems: function () {
      return Object.assign({}, items);
    },
  };
})();
